import { connectedAccountsColumns } from '@/Pejer/columns/ConnectedAccounts'

import { defaultTables } from 'pejer/src/stores/config'
import type { Config, TableConfig } from 'pejer/src/types/base'
import { baseConfig } from './baseConfig'
import { invoicesColumns } from './columns/Invoices'
import { paymentsColumns } from './columns/Payments'
import { partialPayoutsColumns } from './columns/Payouts'
import personsOfInterestColumns from './columns/PersonsOfInterest'
import { refundRequestsColumns } from './columns/RefundRequests'
import {
  ConnectedAccountEmbedFullSchema,
  ConnectedAccountEmbedGroups,
  ConnectedAccountEmbedListSchema,
} from './tables/ConnectedAccounts'
import {
  InvoicesEmbedFullSchema,
  InvoicesEmbedGroups,
  InvoicesEmbedListSchema,
} from './tables/Invoices'
import {
  PaymentsEmbedFullSchema,
  PaymentsEmbedGroups,
  PaymentsEmbedListSchema,
} from './tables/Payments'
import {
  PayoutsEmbedFullSchema,
  PayoutsEmbedGroups,
  PayoutsEmbedListSchema,
} from './tables/Payouts'
import {
  PersonsOfInterestEmbedFullSchema,
  PersonsOfInterestEmbedListSchema,
  PersonsOfInterestGroups,
} from './tables/PersonsOfInterest'
import { RefundRequestEmbedGroups, RefundRequestEmbedListSchema } from './tables/RefundRequests'

export const embeddablesTables = {
  ...defaultTables,
  connectedAccounts: {
    list: ConnectedAccountEmbedListSchema,
    full: ConnectedAccountEmbedFullSchema,
    groups: ConnectedAccountEmbedGroups,
  },
  invoices: {
    list: InvoicesEmbedListSchema,
    full: InvoicesEmbedFullSchema,
    groups: InvoicesEmbedGroups,
  },
  personsOfInterest: {
    list: PersonsOfInterestEmbedListSchema,
    full: PersonsOfInterestEmbedFullSchema,
    groups: PersonsOfInterestGroups,
  },
  payments: {
    list: PaymentsEmbedListSchema,
    full: PaymentsEmbedFullSchema,
    groups: PaymentsEmbedGroups,
  },
  payouts: {
    list: PayoutsEmbedListSchema,
    full: PayoutsEmbedFullSchema,
    groups: PayoutsEmbedGroups,
  },
  refundRequests: {
    list: RefundRequestEmbedListSchema,
    full: RefundRequestEmbedListSchema,
    groups: RefundRequestEmbedGroups,
  },
} satisfies TableConfig

export const config = {
  ...(baseConfig as unknown as Config<typeof baseConfig.urls, typeof embeddablesTables>),
  schema: {
    tables: embeddablesTables,
  },
  columns: {
    connectedAccounts: connectedAccountsColumns,
    invoices: invoicesColumns,
    personsOfInterest: personsOfInterestColumns,
    payments: paymentsColumns,
    payouts: partialPayoutsColumns,
    refundRequests: refundRequestsColumns,
  },
} as const satisfies Config<typeof baseConfig.urls, typeof embeddablesTables>
